export interface TimelineEvent {
  id: string;
  year: number;
  yearRange?: string;
  title: string;
  description: string;
  category: string;
  locations: string[];
  keyFigures: string[];
  sourcePublications: string[];
  mapCoordinates?: { x: number; y: number };
}

export const timelineEvents: TimelineEvent[] = [
  {
    id: "100-collapse-of-nubian-empire",
    year: 100,
    title: "Collapse of Nubian Empire",
    description: "The collapse of the Nubian Empire in Meroe led to a significant influx of immigrants to Africa South of the Sahara.",
    category: "founding",
    locations: ["Meroe", "Sudan"],
    keyFigures: [],
    sourcePublications: ["The Emergence of Oduduwa and the Origin of Yoruba Kingdoms of South-Western Nigeria"],
    mapCoordinates: { x: 85, y: 25 }
  },
  {
    id: "1000-oduduwa-revolution-in-ile-ife",
    year: 1000,
    yearRange: "1000-1420",
    title: "Oduduwa Revolution in Ile-Ife",
    description: "Newcomers led by Oduduwa established indigenous political systems and unified thirteen semi-autonomous lineage-settlements into one central administration.",
    category: "founding",
    locations: ["Ile-Ife"],
    keyFigures: ["Oduduwa"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "ILE-IFE: THE GENESIS OF YORUBA RACE AND SOURCE OF CIVILIZATION"],
    mapCoordinates: { x: 45, y: 55 }
  },
  {
    id: "1128-founding-of-erin-oke",
    year: 1128,
    title: "Founding of Erin-Oke",
    description: "Ifadase, son of Queen Akinla, settled at Erin-Oke and was established as a king with a beaded crown approved by Obalufon Alayemore.",
    category: "founding",
    locations: ["Erin-Oke", "Erin-Ijesa"],
    keyFigures: ["Ifadase", "Queen Akinla", "Obalufon Alayemore"],
    sourcePublications: ["IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 47, y: 52 }
  },
  {
    id: "1170-founding-of-benin-kingdom",
    year: 1170,
    yearRange: "1170-1200",
    title: "Founding of Benin Kingdom",
    description: "Oranyan migrated from Ile-Ife to extend divine kingship to Benin, placing his son Eweka I in charge as the first divine-king.",
    category: "founding",
    locations: ["Benin Kingdom"],
    keyFigures: ["Oranyan", "Eweka I"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "The Emergence of Oduduwa and the Origin of Yoruba Kingdoms of South-Western Nigeria"],
    mapCoordinates: { x: 60, y: 50 }
  },
  {
    id: "1200-founding-of-oyo-kingdom",
    year: 1200,
    yearRange: "1200-1300",
    title: "Founding of Oyo Kingdom",
    description: "Oranyan migrated from Ile-Ife to found the Oyo Kingdom in the far northwest near the Niger River.",
    category: "founding",
    locations: ["Oyo-Ile"],
    keyFigures: ["Oranyan"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY"],
    mapCoordinates: { x: 35, y: 35 }
  },
  {
    id: "1410-founding-of-ibadan",
    year: 1410,
    title: "Founding of Ibadan",
    description: "Prince Adio Lagelu, son of Luwo Gbagida, founded the city of Ibadan.",
    category: "founding",
    locations: ["Ibadan"],
    keyFigures: ["Prince Adio Lagelu", "Luwo Gbagida"],
    sourcePublications: ["IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 40, y: 50 }
  },
  {
    id: "1425-foundation-of-iseri",
    year: 1425,
    yearRange: "1425-1505",
    title: "Foundation of Iseri",
    description: "A small group of Awori-Yoruba under the leadership of Ogunfunminire from the royal house of Ife settled and built Iseri.",
    category: "founding",
    locations: ["Iseri"],
    keyFigures: ["Ogunfunminire"],
    sourcePublications: ["FOUNDATION AND GROWTH OF IBADAN TRADITIONAL SOCIETY..."],
    mapCoordinates: { x: 43, y: 68 }
  },
  {
    id: "1472-portuguese-landing-at-lagos",
    year: 1472,
    title: "Portuguese Landing at Lagos",
    description: "A Portuguese expedition led by Ruy de Sequeira landed at Eko and renamed it Lagos, describing it as a submerged area surrounded by mangroves.",
    category: "colonial",
    locations: ["Lagos", "Eko", "Lagos Island"],
    keyFigures: ["Ruy de Sequeira"],
    sourcePublications: ["FOUNDATION AND GROWTH OF IBADAN TRADITIONAL SOCIETY...", "The Emergence of Oduduwa and the Origin of Yoruba Kingdoms of South-Western Nigeria"],
    mapCoordinates: { x: 42, y: 70 }
  },
  {
    id: "1505-benin-invasion-of-lagos",
    year: 1505,
    yearRange: "1505-1578",
    title: "Benin Invasion of Lagos",
    description: "The Benin army under King Orhoghua invaded Iddo in Lagos, during which Lagelu and the Agura of Gbagura supported the local Olofin.",
    category: "war",
    locations: ["Iddo", "Lagos"],
    keyFigures: ["Oba Orhoghua", "Lagelu", "Olofin Ogunfunminire"],
    sourcePublications: ["ILE-IFE: THE GENESIS OF YORUBA RACE AND SOURCE OF CIVILIZATION"],
    mapCoordinates: { x: 42, y: 70 }
  },
  {
    id: "1520-era-of-the-first-ibadan-settlement",
    year: 1520,
    yearRange: "1520-1824",
    title: "Era of the First Ibadan Settlement",
    description: "This period covers the first settlement established by Lagelu at Igbo-Ipara which endured for over three centuries.",
    category: "founding",
    locations: ["Ibadan", "Igbo-Ipara"],
    keyFigures: ["Lagelu"],
    sourcePublications: ["IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 40, y: 50 }
  },
  {
    id: "1530-sack-of-old-oyo-kingdom",
    year: 1530,
    yearRange: "1530-1542",
    title: "Sack of Old Oyo Kingdom",
    description: "Nupe (Tapa) forces sacked the Old Oyo capital during the reign of Alaafin Onigbogi, forcing the royalty into exile at Gbere.",
    category: "war",
    locations: ["Oyo-Ile", "Gbere", "Ibariba country"],
    keyFigures: ["Alaafin Onigbogi", "Lagelu"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "A COMPREHENSIVE HISTORY OF THE THIRD EMERGENCE...", "IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 35, y: 35 }
  },
  {
    id: "1580-founding-of-the-first-ibadan",
    year: 1580,
    yearRange: "1580-1590",
    title: "Founding of the First Ibadan",
    description: "Lagelu, an Ife war-chief, founded the first Ibadan (Eba-Odan) as a settled life in the forest of Igbo Ipara.",
    category: "founding",
    locations: ["Ibadan", "Eba-Odan", "Igbo Ipara"],
    keyFigures: ["Lagelu"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "FOUNDATION AND GROWTH OF IBADAN TRADITIONAL SOCIETY..."],
    mapCoordinates: { x: 40, y: 50 }
  },
  {
    id: "1580-reign-of-alaafin-abipa",
    year: 1580,
    yearRange: "1580-1590",
    title: "Reign of Alaafin Abipa",
    description: "Alaafin Abipa reigned during the period when the Oyo government returned from exile to settle at Igboho.",
    category: "governance",
    locations: ["Igboho"],
    keyFigures: ["Alaafin Abipa"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY"],
    mapCoordinates: { x: 37, y: 38 }
  },
  {
    id: "1590-oyo-expansion-attempt",
    year: 1590,
    yearRange: "1590-1600",
    title: "Oyo Expansion Attempt",
    description: "Alaafin Obalokun Aganna Erin led an unsuccessful military attempt to subjugate the Ijesha people.",
    category: "war",
    locations: ["Ijesha"],
    keyFigures: ["Alaafin Obalokun Aganna Erin"],
    sourcePublications: ["The Emergence of Oduduwa and the Origin of Yoruba Kingdoms of South-Western Nigeria"],
    mapCoordinates: { x: 48, y: 48 }
  },
  {
    id: "1600-reign-of-oba-ajagbo",
    year: 1600,
    yearRange: "1600-1658",
    title: "Reign of Oba Ajagbo",
    description: "Under Oba Ajagbo, military institutions reached advanced forms and the office of Aare-Ona-Kakanfo was established.",
    category: "governance",
    locations: ["Oyo"],
    keyFigures: ["Oba Ajagbo"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY"],
    mapCoordinates: { x: 35, y: 35 }
  },
  {
    id: "1610-return-of-oyo-government-to-oyo-ile",
    year: 1610,
    title: "Return of Oyo Government to Oyo-Ile",
    description: "After years in exile at Igboho, the seat of the Oyo government was transferred back to the original capital of Oyo-Ile.",
    category: "governance",
    locations: ["Oyo-Ile", "Igboho"],
    keyFigures: ["Egungunoju", "Alaafin Obalokun"],
    sourcePublications: ["A COMPREHENSIVE HISTORY OF THE THIRD EMERGENCE..."],
    mapCoordinates: { x: 35, y: 35 }
  },
  {
    id: "1640-institution-of-aare-ona-kakanfo",
    year: 1640,
    title: "Institution of Aare-Ona-Kakanfo",
    description: "Alaafin Ajagbo established the office of Aare-Ona-Kakanfo as the General Officer Commanding the Imperial Oyo Army and head of the Esos.",
    category: "governance",
    locations: ["Oyo Empire"],
    keyFigures: ["Alaafin Ajagbo", "Kokorogangan"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "FOUNDATION AND GROWTH OF IBADAN TRADITIONAL SOCIETY..."],
    mapCoordinates: { x: 35, y: 35 }
  },
  {
    id: "1698-destruction-of-the-first-ibadan",
    year: 1698,
    yearRange: "1698-1774",
    title: "Destruction of the First Ibadan",
    description: "The first Ibadan settlement was destroyed by the Oyo army during the reign of Alaafin Ojigi after the secrets of the Egungun masquerade were exposed.",
    category: "war",
    locations: ["Ibadan"],
    keyFigures: ["Alaafin Ojigi", "Lagelu", "Alaafin Abiodun Adegolu"],
    sourcePublications: ["A COMPREHENSIVE HISTORY OF THE THIRD EMERGENCE...", "IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 40, y: 50 }
  },
  {
    id: "1754-constitutional-upheaval-of-basorun-gaha",
    year: 1754,
    yearRange: "1754-1774",
    title: "Constitutional Upheaval of Basorun Gaha",
    description: "A period of distress where Basorun Gaha subverted the Oyo constitution by raising and killing four successive Alaafins.",
    category: "governance",
    locations: ["Oyo Empire"],
    keyFigures: ["Basorun Gaha", "Alaafin Labisi", "Alaafin Awobioju"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 35, y: 35 }
  },
  {
    id: "1774-reign-of-alaafin-abiodun",
    year: 1774,
    yearRange: "1774-1789",
    title: "Reign of Alaafin Abiodun",
    description: "Alaafin Abiodun Adegolu restored order and halted Gaha's excesses, marking the last era of prosperity and universal sway for Oyo.",
    category: "governance",
    locations: ["Oyo Empire", "Yoruba Country"],
    keyFigures: ["Alaafin Abiodun Adegolu"],
    sourcePublications: ["A NEW PERSPECTIVE OF IBADAN HISTORY", "FOUNDATION AND GROWTH OF IBADAN TRADITIONAL SOCIETY...", "IBADAN HISTORY FROM THE SIXTEENTH CENTURY TO THE BRITISH COLONIAL PERIOD"],
    mapCoordinates: { x: 35, y: 35 }
  }
];
